import { AgentNotificationComponent } from '@agent/layout/nav-bar/notifications/notification/notification.component';
import { AgentNotificationsOverviewModalComponent } from '@agent/layout/nav-bar/notifications/notifications-overview-modal/notifications-overview-modal.component';
import { StateService } from '@infra/state/state.service';
import { Component, inject, type OnDestroy, type OnInit, TemplateRef, ViewChild } from '@angular/core';
import { type NotificationDTO, type NotificationListRequestDTO } from '@api/models';
import { NotificationService } from '@api/services/notification.service';
import { NgbDropdown, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { KeyboardClickableDirective } from '@common/directives/keyboard-clickable.directive';
import { type Subscription } from 'rxjs';

@Component({
  selector: 'app-agent-notifications-dropdown',
  templateUrl: './notifications-dropdown.component.html',
  imports: [
    KeyboardClickableDirective,
    AgentNotificationComponent,
    AgentNotificationsOverviewModalComponent,
    NgbDropdownModule,
    TranslatePipe,
  ],
})
export class AgentNotificationsDropdownComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService);
  private readonly stateService = inject(StateService);
  private readonly modalService = inject(NgbModal);

  notifications: NotificationDTO[];
  totalNotifications = 0;
  totalUnreadNotifications = 0;

  @ViewChild(NgbDropdown, { static: false }) private readonly dropdown: NgbDropdown;
  subscription: Subscription;

  ngOnInit(): void {
    this.notificationService.countUnread().subscribe(result => {
      this.totalUnreadNotifications = result;
    });

    this.subscription = this.stateService.unreadNotificationCount$.subscribe(unreadNotificationCount => {
      this.totalUnreadNotifications = unreadNotificationCount;
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  checkDropDown(open: boolean) {
    if (open) {
      this.getAllNotifications();
    }
  }

  closeDropdown(): void {
    this.notifications = [];
    this.dropdown.close();
  }

  showNotificationsModal(content: TemplateRef<Element>): void {
    this.modalService.open(content, { size: 'lg' });
  }

  // Notification
  private getAllNotifications(): void {
    const request = {
      first: 0,
      rows: 5,
      sortField: 'addedDateTime',
      sortOrder: -1,
    } satisfies NotificationListRequestDTO;

    this.notificationService.list(request, true).subscribe(response => {
      this.notifications = response.data;
      this.totalNotifications = response.total;
    });
  }
}
